import {Component, ElementRef, EventEmitter, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-number-changer',
    templateUrl: './number-changer.component.html',
    styleUrl: './number-changer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberChangerComponent {
  @ViewChild('number')  numberElementRef?: ElementRef<HTMLInputElement>

  @Output() change = new EventEmitter<number>()

  onMinus() {
    if (this.numberElementRef === undefined) {
      return
    }

    let value = Number(this.numberElementRef.nativeElement.value)

    value = parseFloat((value - 0.1).toFixed(1))

    if (value < 0) {
      value = 0
    }

    this.change.emit(value)

    this.numberElementRef.nativeElement.value = String(value)
  }

  setValue(value: number) {
    if (this.numberElementRef === undefined) {
      return
    }

    this.numberElementRef.nativeElement.value = String(value)
  }

  onPlus() {
    if (this.numberElementRef === undefined) {
      return
    }

    let value = Number(this.numberElementRef.nativeElement.value)

    value = parseFloat((value + 0.1).toFixed(1))

    if (value > 100) {
      value = 100
    }

    this.change.emit(value)

    this.numberElementRef.nativeElement.value = String(value)
  }

  onNumberChange(e: Event) {
    e.stopPropagation()
    const input = e.target as HTMLInputElement

    let value = Number(input.value)

    if (isNaN(value)) {
      value = 0
    }

    if (value < 0) {
      value = 0
    }

    if (value > 100) {
      value = 100
    }

    this.change.emit(Number(value))
  }
}
